// _neu_generated_code__dont_modify_directly_
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
//CORE_REFERENCE_IMPORTS
//append_imports_start

import { Component, Injector } from '@angular/core'; //_splitter_
import { SDPageCommonService } from 'app/n-services/sd-page-common.service'; //_splitter_
import { SDBaseService } from 'app/n-services/SDBaseService'; //_splitter_
import { NeuServiceInvokerService } from 'app/n-services/service-caller.service'; //_splitter_
//append_imports_end

@Component({
  selector: 'bh-auth',
  templateUrl: './auth.template.html',
  providers: [
    //appendnew_element_providers
  ],
})
export class authComponent {
  page: any = { dep: {} };
  constructor(
    private __page_injector__: Injector,
    private sdService: SDBaseService,
    public __serviceInvoker__: NeuServiceInvokerService
  ) {
    this.__page_injector__.get(SDPageCommonService).addPageDefaults(this.page);
    this.registerListeners();
    //appendnew_element_inject
  }

  ngOnInit() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    {
      this.sd_nkycR1jHkYIfqSOb(bh);
    }
  }

  private registerListeners() {
    let bh = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);

    //append_listeners
  }

  sd_nkycR1jHkYIfqSOb(bh) {
    try {
      bh = this.sd_wvXF6jPsNcrvAwIl(bh);
      //appendnew_next_sd_nkycR1jHkYIfqSOb
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_nkycR1jHkYIfqSOb');
    }
  }

  onLogin(...others) {
    let bh: any = {};
    try {
      bh = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh.input = {};
      bh.local = {};
      bh = this.sd_82umaYUsfHx1NBsX(bh);
      //appendnew_next_onLogin
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_1NX3a0dcpe6oRMmf');
    }
  }
  //appendnew_flow_authComponent_start

  sd_wvXF6jPsNcrvAwIl(bh) {
    try {
      //appendnew_next_sd_wvXF6jPsNcrvAwIl
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_wvXF6jPsNcrvAwIl');
    }
  }

  sd_82umaYUsfHx1NBsX(bh) {
    try {
      const page = this.page;
      console.log('login', bh);
      bh.system.oauthService.login();
      //appendnew_next_sd_82umaYUsfHx1NBsX
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_82umaYUsfHx1NBsX');
    }
  }

  //appendnew_node

  ngOnDestroy() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    this.__page_injector__.get(SDPageCommonService).deletePageFromMap(this);
  }

  // error_handler_slot
  private errorHandler(bh, e, src): Promise<any> {
    console.error(e);
    bh.error = e;
    bh.errorSource = src;
    throw e;
  }
  //appendnew_flow_authComponent_Catch
}
